export const SPARK_PRODUCT = 'spark';
export const SLEEPIO_PRODUCT = 'sleepio';

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please double check your information and try again.';

export const SLEEPIO_APP_STORE_URL = 'https://apps.apple.com/ca/app/sleepio-3-0/id6698893964';

export const SLEEPIO_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.bighealth.cortex.sleepio';

export const SPARK_APP_STORE_URL = 'https://apps.apple.com/us/app/spark-direct/id1509813684';

export const SPARK_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.limbix.protem&hl=en';
